export default Object.freeze({
  None: 1,
  ResponseMapping: 2,
});
